const state = {
  transcodeSettings: {
    maxAnimationDuration: 30, // seconds
    maxBitrate: '3M',
    maxVideoDimensions: {
      alpha: {
        w: 960,
        h: 1080
      },
      noAlpha: {
        w: 1920,
        h: 1080
      }
    }
  },
  godModeSettings: {
    maxAnimationDuration: 86400, // 24hrs
    maxBitrate: 8
  },
  planSettings: {
    // free
    freeViewLimit: 100,
    freePanelsPublishLimit: 1,
    freePanelsSizeLimit: 3,
    freeArtworkDurationLimit: 30,
    // artist
    artistViewLimit: 10000,
    artistPanelsPublishLimit: 3,
    artistPanelsSizeLimit: 20,
    artistArtworkDurationLimit: 60,
    // business/virtuoso
    virtuosoViewLimit: 100000,
    virtuosoPanelsPublishLimit: 10,
    virtuosoPanelsSizeLimit: 50,
    virtuosoArtworkDurationLimit: 120,
  }
};

const getters = {
  transcodeSettings() {
    return state.transcodeSettings;
  },
  godModeSettings() {
    return state.godModeSettings;
  },
  godModeBitrate() {
    return `${state.godModeSettings.maxBitrate}M`;
  },
  planSettings() {
    return state.planSettings;
  },
};

const mutations = {
  SET_MAX_ANIMATION_DURATION(state, payload) {
    state.transcodeSettings.maxAnimationDuration = payload.maxAnimationDuration;
  },
  SET_GODMODE_MAXBITRATE(state, payload) {
    state.godModeSettings.maxBitrate = payload.maxBitrate;
  },
  SET_PLAN_SETTINGS(state, payload) {
    // state.planSettings.freeViewLimit = payload.free;
    // state.planSettings.artistViewLimit = payload.artist;
    // state.planSettings.virtuosoViewLimit = payload.virtuoso;
    state.planSettings.freeViewLimit = payload.freeViewLimit;
    state.planSettings.freePanelsPublishLimit = payload.freePanelsPublishLimit;
    state.planSettings.freePanelsSizeLimit = payload.freePanelsSizeLimit;
    state.planSettings.freeArtworkDurationLimit = payload.freeArtworkDurationLimit;
    state.planSettings.artistViewLimit = payload.artistViewLimit;
    state.planSettings.artistPanelsPublishLimit = payload.artistPanelsPublishLimit;
    state.planSettings.artistPanelsSizeLimit = payload.artistPanelsSizeLimit;
    state.planSettings.artistArtworkDurationLimit = payload.artistArtworkDurationLimit;
    state.planSettings.virtuosoViewLimit = payload.virtuosoViewLimit;
    state.planSettings.virtuosoPanelsPublishLimit = payload.virtuosoPanelsPublishLimit;
    state.planSettings.virtuosoPanelsSizeLimit = payload.virtuosoPanelsSizeLimit;
    state.planSettings.virtuosoArtworkDurationLimit = payload.virtuosoArtworkDurationLimit;
  },
};

const actions = {
  setMaxAnimationDuration({ commit }, payload) {
    commit('SET_MAXANIMATION_DURATION', payload);
  },
  setMaxBitrate({ commit }, payload) {
    commit('SET_MAXBITRATE', payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
